import { cn } from '@bazaar-marketplace/utils';
import { Slot } from '@radix-ui/react-slot';
import { hapticFeedback } from '@telegram-apps/sdk-react';
import type { FC } from 'react';

import type { ButtonProps } from './types';
import { buttonVariants } from './variants';

export const Button: FC<ButtonProps> = ({
  className,
  variant,
  asChild = false,
  loading = false,
  onClick,
  disabled,
  ...props
}) => {
  const Comp = asChild ? Slot : 'button';

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    // Add haptic feedback for rainbow variant
    if (variant === 'rainbow' && hapticFeedback.isSupported()) {
      hapticFeedback.impactOccurred('medium');
    }

    // Call original onClick if provided and not loading
    if (onClick && !loading) {
      onClick(event);
    }
  };

  return (
    <Comp
      className={cn(buttonVariants({ variant }), className)}
      data-slot="button"
      disabled={disabled || loading}
      onClick={handleClick}
      {...props}
    />
  );
};
